import React from "react";
import { classNames } from "../../utils";
import Icon from "./Icon";
import { useTemplateSetting } from "../../hooks/useCompanySettings";
import { PRICE_STATUS, TOOL_TEMPLATE } from "../../constant/common";
import {i18n} from "@euroland/libs";

const PriceUpDown = ({ status, children }) => {
  const template = useTemplateSetting();
  const ariaLabel = status === PRICE_STATUS.UP ? i18n.translate('priceUpLabel') : i18n.translate('priceDownLabel')
  return (
    <div
      className={classNames("price", {
        "price-up": status === PRICE_STATUS.UP,
        "price-down": status === PRICE_STATUS.DOWN,
      })}
    >
     {(template === TOOL_TEMPLATE.quadrata || template === TOOL_TEMPLATE.victor) && (
       <Icon
         role="img"
         className="downIcon"
         aria-label={ariaLabel}
         name={status === PRICE_STATUS.UP ? "triangle-up" : "triangle-down"}
       />
     )}
     {children}
    </div>
  );
};


export default PriceUpDown;
